const $html = $('html');

const observer = () => {
    const target = document.querySelector('.footer');

    const options = {
      root: null,
      rootMargin: '-1px 0px',
      threshold: 0,
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
            // $html.removeClass('-fixed');
        }
      });
    }, options);

    observer.observe(target);
};

PubSub.subscribe('init', () => {
  observer();
});

$window = $(window)

PubSub.subscribe('scroll', (_msg, {scrollDirection, scrollTop}) => {
  if (scrollTop <= 0) {
    $html.removeClass('-fixed');
  }
});